export default __webpack_public_path__ + "static/media/wildLife.97d83dee.svg";